import _BaseAPIService from "../_BaseAPIService";

const instance = _BaseAPIService.instance;

export const DatabaseMgmt = {
  getAll: async () => {
    try {
      const response = await instance.get("/databasemanagement");
      // console.log("DataManagement Response:", response.data);
      return response.data;
    } catch (error) {
      console.error( error);
      throw error;
    }
  },
  getByID: async (databaseId) =>{
    try{
      const response = await instance.get(`/databasemanagement/${databaseId}`)
      return response.data;
    }catch(err){
      console.error(err)
      throw err;
    }
  }
}

